export function ConfirmModal(MessageTitle?: string, ConfirmationOption?: string, CancelmOption?: string) {
    return new Promise((resolve) => {
        let IsClosed = false;
        const modal = $("#confirmModal") as any;
        modal.unbind().on("hidden.bs.modal", () => !IsClosed ? resolve(false) : "");
        modal.modal("show");

        const {ConfirmTitle, CancelText, ConfirmationText} = GetModalElements();
        ConfirmTitle.empty().append(MessageTitle ? MessageTitle : "Confirm");
        ConfirmationText.empty().append(ConfirmationOption ? ConfirmationOption : "Ok");
        ConfirmationText.unbind().one('click', () => {
            IsClosed = true;
            HandleOptionChange(modal, true, resolve);
        });
        CancelText.empty().append(CancelmOption ? CancelmOption : "Cancel");
        CancelText.unbind().one("click", () => {
            IsClosed = true;
            HandleOptionChange(modal, false, resolve);
        });
    });
}

function HandleOptionChange(modal: any, chosenOption: boolean, resolve: Function) {
    modal.modal("hide");
    resolve(chosenOption);
}

function GetModalElements(): { ConfirmTitle: any, CancelText: any, ConfirmationText: any } {
    const ConfirmTitle = $("#confirmTitle");
    const CancelText = $("#confirmCancel") as any;
    const ConfirmationText = $("#confirmOk") as any;
    return {ConfirmTitle, CancelText, ConfirmationText}
}


// WEBPACK FOOTER //
// ./src/helpers/ModalHelper.ts